import { Routes } from "@angular/router";
import { EventGuard, EventsListGuard, LoginGuard, OfflineGuard, ShortcodeGuard } from "./shared/guards";
import { ModulesGuard } from "./shared/guards/guards";
import { PathComponents } from "./shared/paths/path-components";
import { EventUserResolver, EventsResolver, NotificationsResolver } from "./shared/resolvers";

export const routes: Routes = [
	{
		path: "",
		redirectTo: "/login",
		pathMatch: "full"
	},
	{
		path: "login",
		canActivate: [LoginGuard],
		component: PathComponents.login
	},

	{
		path: "login/:eventId",
		canActivate: [LoginGuard],
		component: PathComponents.login
	},
	{
		path: "events-list/:type", // Type can be all, publics or my-events
		canActivate: [EventsListGuard],
		component: PathComponents.eventsList
	},
	{
		path: "event/:eventId",
		canActivate: [EventGuard, ModulesGuard],
		resolve: {
			event: EventsResolver,
			eventUser: EventUserResolver
		},
		loadChildren: () => import("./content/pages/event/event.routes").then((m) => m.EVENT_ROUTES)
	},
	{
		path: "notifications/:eventId/:displayNotifId/:openTime",
		resolve: {
			event: EventsResolver,
			eventUser: EventUserResolver,
			notifications: NotificationsResolver
		},
		loadComponent: () =>
			import("./content/pages/event/components/modals/notifications/notifications.component").then(
				(m) => m.NotificationsComponent
			)
	},
	{
		path: "shortcode/:shortCodeId",
		canActivate: [ShortcodeGuard],
		component: PathComponents.splash // All logics for this route is on the guard
	},
	{ path: "reset-password", component: PathComponents.resetPassword },
	{
		path: "offline",
		canActivate: [OfflineGuard],
		loadComponent: () => import("./content/pages/offline/offline.page")
	},
	{
		path: "beta-program",
		loadComponent: () => import("./content/pages/beta-program/beta-program.page")
	},
	{
		path: "**",
		redirectTo: "/login",
		pathMatch: "full"
	}
];
